import { useBlockProps, RichText } from '@wordpress/block-editor';

export default function Save({ attributes }) {
  const { slides = [] } = attributes;

  if (slides.length === 0) return null;

  return (
    <div {...useBlockProps.save()}>
    <div
      id="homeHeaderSlider"
      className="carousel slide greenbg carousel-fade mob-none"
      data-bs-ride="carousel"
    >
      <div className="carousel-inner">
        {slides.map((slide, i) => (
          <div
            key={i}
            className={`carousel-item ${i === 0 ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.backgroundImage})` }}
            data-bs-interval="5000"
          >
            <div className="container-xl h-100">
              <div className="row h-100">
                <div className="col-md-12 d-flex align-items-center">
                  <div class="carosuel-caption d-md-block">
                    <h1>
                      {slide.title}{' '}
                      <span className="text-yellow">{slide.secondTitle}</span>
                    </h1>
                    <RichText.Content tagName="p" value={slide.text} />
                    <a href={slide.buttonUrl} className="btn btn-primary btn-lg">
                      <RichText.Content value={slide.buttonText} />
                    </a>
                  </div>
                  <div className="carosuel-img">
                    {slide.rightImage && (
                      <img src={slide.rightImage} alt="" style={{ width: '100%' }} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Carousel Indicators */}
      <div className="carousel-indicators">
        {slides.map((_, i) => (
          <button
            key={i}
            type="button"
            data-bs-target="#homeHeaderSlider"
            data-bs-slide-to={i}
            className={i === 0 ? 'active' : ''}
            aria-current={i === 0 ? 'true' : undefined}
            aria-label={`Slide ${i + 1}`}
          ></button>
        ))}
      </div>

      {/* Controls (arrows) */}
  <button class="carousel-control-prev" type="button" data-bs-target="#homeHeaderSlider" data-bs-slide="prev">
    <span class="carousel-control-prev-icon"></span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#homeHeaderSlider" data-bs-slide="next">
    <span class="carousel-control-next-icon"></span>
  </button>
    </div>
    </div>
  );
}
